import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { richTextValidation } from "@validations/utils";

export const PROCUREMENT_DETAILS = FORM_FIELDS.PROCUREMENT_DETAILS;
export const RICH_TEXT_EDITOR =
  FORM_FIELDS.PROCUREMENT_DETAILS.RICH_TEXT_EDITOR;

const {
  APP_PACKAGE_ID,
  DEMAND_IDS,
  DOCUMENTS,
  ITEMS,
  NAME_BN,
  NAME_EN,
  REF_NO,
  APP_ID,
  BUDGET_QUARTER,
  // COMPLETION_DATE,
  // LAST_SUBMISSION_DATE,
  PACKAGE_BUDGET_ID,
  // PUBLISH_DATE,
  PACKAGE_BUDGET_QUARTER,
  EXTRA_COST_AMOUNT,
  EXTRA_COST_INFO,
} = PROCUREMENT_DETAILS;

export const procurementDetailsValidation = yup.object().shape({
  [NAME_BN]: yup.string().required("Name is required"),
  [NAME_EN]: yup.string().required("Name is required"),
  [REF_NO]: yup.string().required("Ref no. is required"),
  [APP_PACKAGE_ID]: yup
    .number()
    .typeError("Package ID is required")
    .required("Package ID is required"),
  [PACKAGE_BUDGET_ID]: yup
    .number()
    .typeError("Package Budget ID is required")
    .required("Package Budget ID is required"),
  [PACKAGE_BUDGET_QUARTER]: yup
    .string()
    .typeError("Package Budget Quarter is required")
    .required("Package Budget Quarter is required"),
  [APP_ID]: yup
    .number()
    .typeError("APP ID is required")
    .required("APP ID is required"),
  [EXTRA_COST_AMOUNT]: yup
    .number()
    .transform((value) => {
      if (isNaN(value) || value === "") {
        return null; // Convert NaN to null
      }
      return value;
    })
    .nullable()
    .typeError("Extra cost amount is must be a number"),
  [EXTRA_COST_INFO]: yup.string().nullable(),
  // [RICH_TEXT_EDITOR]: richTextValidation(),
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
  [ITEMS]: yup
    .array()
    .of(
      yup.object().shape({
        itemId: yup.number(),
        unitPrice: yup
          .number()
          .typeError("Unit price is required")
          .required("Unit price is required"),
        quantity: yup
          .number()
          .typeError("Quantity is required")
          .required("Quantity is required"),
      }),
    )
    .nullable(),
  [DEMAND_IDS]: yup.array().of(yup.number()),
  [BUDGET_QUARTER]: yup.string().required("Budget quarter is required"),
  // [COMPLETION_DATE]: yup
  //   .string()
  //   .typeError("Completion Date required")
  //   .required("Completion Date required"),
  // [LAST_SUBMISSION_DATE]: yup
  //   .string()
  //   .typeError("Last Submission Date required")
  //   .required("Last Submission Date required"),
  // [PUBLISH_DATE]: yup
  //   .string()
  //   .typeError("Publish Date Date required")
  //   .required("Publish Date Date required"),
});
